module.exports = __webpack_public_path__ + "img/gdq_gbt5287_1985.prt.a38a1461.jpg";